import { CobaltPageHeader } from '@cae/cobalt-react/components/page-header';
import { InvoiceAlertTiles } from '@features/invoices/components/header/alert-tiles/InvoiceAlertTiles';
import { useInvoiceAlertsData } from '@features/invoices/contexts/alerts/useInvoiceAlertsData';
import { useInvoicesData } from '@features/invoices/contexts/data/useInvoicesData';
import { useInvoicesFilter } from '@features/invoices/contexts/filter/useInvoicesFilter';
import * as React from 'react';

import { InvoicesFilterPanel } from '../filter-panel/InvoicesFilterPanel';
import { InvoicesFilterButton } from './filter-button/InvoicesFilterButton';
import styles from './InvoicesHeader.module.css';
import { InvoicesSearch } from './search/InvoicesSearch';

const InvoicesHeader = React.memo((): React.ReactElement => {
  const { invoices } = useInvoicesData();
  const { invoiceAlerts } = useInvoiceAlertsData();
  const { isSearchApplied, isFiltersApplied } = useInvoicesFilter();

  const [isFiltersPanelOpen, setIsFiltersPanelOpen] =
    React.useState<boolean>(false);

  const controlsDisabled =
    invoices.isLoading &&
    invoices.data.elements.length === 0 &&
    !isSearchApplied &&
    !isFiltersApplied;

  const handleFiltersOpen = React.useCallback((): void => {
    setIsFiltersPanelOpen(true);
  }, []);

  const handleFiltersClose = React.useCallback((): void => {
    setIsFiltersPanelOpen(false);
  }, []);

  return (
    <section data-testid="invoices-header">
      <CobaltPageHeader
        title="Invoices and payments"
        className={styles.header}
        content={
          <div
            data-testid="invoices-header-content"
            className={styles.headerContent}
          >
            <InvoiceAlertTiles alerts={invoiceAlerts} />

            <div className={styles.headerSearchAndFiltersActions}>
              <InvoicesSearch disabled={controlsDisabled} />
              <InvoicesFilterButton
                onFiltersOpen={handleFiltersOpen}
                disabled={controlsDisabled}
              />
            </div>
          </div>
        }
      />
      {isFiltersPanelOpen && (
        <InvoicesFilterPanel onClose={handleFiltersClose} />
      )}
    </section>
  );
});

InvoicesHeader.displayName = 'InvoicesHeader';
export { InvoicesHeader };
